import { UHCImageListProps } from "../ImageList";

export interface ImageIconCardProps {
    setCardChecked: (value: React.SetStateAction<string>) => void,
    cardChecked: Cards,
    layout:UHCImageListProps['layout']
}

export enum Cards {
    'ubuntu' = 'ubuntu',
    'windows' = 'windows',
    'cpanel' = 'cpanel',
    'rocky' = 'rocky',
    'alma' = 'alma',
    'debian' = 'debian',
    'app' = 'app',
}
